import {Component, ElementRef, Inject, OnInit, signal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import {PushpinService} from '../../services/pushpin/pushpin.service';
import {Pushpin} from '../../classes/pushpin.class';
import {LocationService} from '../location-selector-dialog/location.service';
import {CodaltComponent} from "../../codalt.component";
import {MatProgressBar} from "@angular/material/progress-bar";
import {MatButton} from "@angular/material/button";

@Component({
    selector: 'app-create-pushpin-dialog',
    templateUrl: './create-pushpin-dialog.component.html',
    styleUrls: ['./create-pushpin-dialog.component.scss'],
    imports: [
        MatProgressBar,
        MatButton,
        MatDialogContent,
        MatDialogTitle
    ]
})
export class CreatePushpinDialogComponent extends CodaltComponent implements OnInit {

    public readonly checking = signal<boolean>(true);
    public readonly locationSelected = signal<boolean>(false);
    public readonly typeSelected = signal<boolean>(false);

    public readonly addresses = signal<any[]>([]);

    public readonly showExtraCostsButton = signal<boolean>(false);

    constructor(
        private locationService: LocationService,
        private pushpinService: PushpinService,
        private elRef: ElementRef,
        public dialogRef: MatDialogRef<CreatePushpinDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public pushpin: Pushpin
    ) {
        super();
        this.showExtraCostsButton.set(window.matchMedia('(min-width: 1100px)').matches);
    }

    ngOnInit() {
        this.pushpinService.checkNoOpenLengthmark(this.pushpin.customer_area_id).then(maycreate => {
            this.checking.set(false);
            if (!maycreate) {
                this.selectType(false);
            }
        });
        this.locationService.getLocations(this.pushpin.lat, this.pushpin.lng).subscribe(response => {
            if (response && response['resourceSets'][0]['resources']) {
                const newAddresses = [];
                const uniqueCheck = [];
                response['resourceSets'][0]['resources'].forEach(addr => {
                    const flatAdress = addr.address.addressLine + addr.address.postalCode + addr.address.adminDistrict2;
                    if (uniqueCheck.indexOf(flatAdress) === -1) {
                        uniqueCheck.push(flatAdress);
                        newAddresses.push(addr);
                    }
                });
                this.addresses.set(newAddresses);
                if (this.addresses().length === 1) {
                    this.select(this.addresses()[0]);
                    this.locationSelected.set(true);
                } else if (this.addresses().length < 1) {
                    this.locationSelected.set(true);
                }
            } else {
                this.locationSelected.set(true);
            }

            if (this.typeSelected() && this.locationSelected()) {
                this.createPushpin();
            }
        });
    }

    otherType(type) {
        this.dialogRef.close(type);
    }

    selectType(lengthmark) {
        this.typeSelected.set(true);
        this.pushpin.lengthmark = lengthmark;
        if (this.locationSelected()) {
            this.createPushpin();
        }
    }

    select(address) {
        this.setLocation(address);
        this.locationSelected.set(true);
        if (this.typeSelected()) {
            this.createPushpin();
        }
    }

    createPushpin() {
        if (this.pushpin.lengthmark) {
            this.pushpin.draft = true;
        }
        this.pushpinService.savePushpin(this.pushpin).then(pushpin => {
            this.dialogRef.close(pushpin);
        });
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    setLocation(addressData: any) {
        const address = addressData.address;
        let number: any = '0';
        let street: any = '-';


        if (typeof address.addressLine !== 'undefined') {
            number = address.addressLine.split(' ').reverse()[0];

            if (isNaN(number[0])) {
                street = address.addressLine;
                number = '-';
            } else {
                street = address.addressLine.split(' ');

                delete street[street.indexOf(number)];
                street = street.join(' ');
            }
        }

        this.pushpin.zipcode = address.postalCode;
        this.pushpin.street = street;
        this.pushpin.housenumber = number;
        this.pushpin.place = address.locality;
    }
}
